const formatMobilePhone = (mobilePhone) => {
  if (!mobilePhone) return ""

  return mobilePhone.replace("+98", "0")
}

export default formatMobilePhone